import { useContext } from "react";
import NotificationProvider from "../../context/NotificationProvider";

const useNotificationHook = () => {
  return useContext(NotificationProvider);
};

export default useNotificationHook;
